import Scalar from "src/libs/scalars/scalars/Scalar"
import { ICompositeWidgetProps } from "../LandingCompositeWidget"
import FieldInput, { SCALAR_TYPES } from "src/libs/scalars"
import { useEffect, useState } from "react"
import { defaultPosition, IScreenPosition } from "../../data/interfaces"
import { __ } from "src/libs/utilities"
import { Button, ButtonGroup, Intent, Size } from "@blueprintjs/core"

/* Protopia Ecosystem component */
export interface IPositionScalarProps extends ICompositeWidgetProps {
   disabled_fields?: (keyof IScreenPosition)[]
}
const PositionScalar = (props: IPositionScalarProps): JSX.Element => {
    return <>
        <Scalar 
            title={props.title}
            value={props.value}
            editable={props.editable}
            notClear
            enabledForm={<PositionEnabled {...props} />}  
            desabledForm={<PositionDisable {...props} />}  
            subMenus={props.subMenus}
            onSubMenu={props.onSubmenu} 
        />
    </>
}
export default PositionScalar

const PositionEnabled = (props: IPositionScalarProps): JSX.Element => {
    const [horz, setHorz]   = useState<"left" | "right">( typeof props.value?.right  !== "undefined" ? "right"   : "left")
    const [vert, setVert]   = useState<"top" | "bottom">( typeof props.value?.bottom !== "undefined" ? "bottom"  : "top")
    const [value, setValue] = useState<any>( props.value || props.default || defaultPosition() )
    const {disabled_fields} = props
    useEffect(() => {        
        setHorz( typeof props.value?.right  !== "undefined" ? "right"  : "left" )
        setVert( typeof props.value?.bottom !== "undefined" ? "bottom" : "top" )
        setValue( props.value )
    }, [ props.value ])

    const onChange = (val: any, field: string, dop: any) => {
        if(props.onChange) {
            props.onChange(
                { ...value, [field]: val }, 
                props.field, 
                "" 
            )
        }
        else {
            setValue({ ...value, [field]: val })
        }
    }

    const onHorz = (val: "left" | "right") => {
        const noVal = val === "left" ? "right": "left"
        if(props.onChange) {
            props.onChange(
                { 
                    ...value, 
                    [noVal]: undefined,
                    [val]: value[noVal] || 0,
                }, 
                props.field, 
                "" 
            )
        }
        else {
            setValue({ 
                ...value, 
                [noVal]: undefined,
                    [val]: value[noVal] || 0,
            })
        } 
    }
    const onVert = (val: "top" | "bottom") => {
        const noVal = val === "top" ? "bottom": "top"
        if(props.onChange) {
            props.onChange(
                { 
                    ...value, 
                    [noVal]: undefined,
                    [val]: value[noVal] || 0,
                }, 
                props.field, 
                "" 
            )
        }
        else {
            setValue({ 
                ...value, 
                [noVal]: undefined,
                    [val]: value[noVal] || 0,
            })
        } 
    }
    const getHorzTitle = (): JSX.Element => {
        const is =  horz === "left"
        return <ButtonGroup size={Size.SMALL} >
            <Button intent={ is ? Intent.PRIMARY : Intent.NONE } variant={is ? "solid" : "minimal"} onClick={() => onHorz("left")}>
                <div className="small">
                    {__("left")}
                </div>
            </Button>
            <Button intent={ !is? Intent.PRIMARY : Intent.NONE } variant={!is ? "solid" : "minimal"} onClick={() => onHorz("right")}>
                <div className="small">
                    {__("right")}
                </div>
            </Button>
        </ButtonGroup> 
    }
    const getVertTitle = (): JSX.Element => {
        const is = vert === "top"
        return <ButtonGroup size={Size.SMALL} >
            <Button intent={ is ? Intent.PRIMARY : Intent.NONE } variant={is ? "solid" : "minimal"} onClick={() => onVert("top")}>
                <div className="small">
                    {__("top")}
                </div>
            </Button>
            <Button intent={ !is? Intent.PRIMARY : Intent.NONE } variant={!is ? "solid" : "minimal"} onClick={() => onVert("bottom")}>
                <div className="small">
                    {__("bottom")}
                </div>
            </Button>
        </ButtonGroup>
    }
    return <div className="container">
        {
            !(disabled_fields || []).includes( horz )  &&  <FieldInput
                type={SCALAR_TYPES.NUMBER} 
                subtitle={ getHorzTitle() }
                field={ horz }
                value={ (value || {})[horz] } 
                editable
                onChange={onChange}
                default={0}
                postfix="pixels"
            />
        }
        {
            !(disabled_fields || []).includes( vert )  &&  <FieldInput
                type={SCALAR_TYPES.NUMBER} 
                subtitle={ getVertTitle() }
                field={ vert }
                value={ (value || {})[vert] } 
                editable
                onChange={onChange}
                default={0}
                postfix="pixels"
            />
       }
       {
            !(disabled_fields || []).includes( "width" )  && <FieldInput
                type={SCALAR_TYPES.NUMBER}
                subtitle="Width"
                field="width"
                value={value?.width } 
                editable
                onChange={onChange}
                default={100}
                postfix="pixels"
            />
        } 
        {
            !(disabled_fields || []).includes( "height" )  && <FieldInput
                type={SCALAR_TYPES.NUMBER}
                subtitle="Height"
                field="height"
                value={value?.height } 
                editable
                onChange={onChange}
                default={100}
                postfix="pixels"
            />        
        } 
        {
            !(disabled_fields || []).includes( "rotate" )  &&  <FieldInput
                type={SCALAR_TYPES.SLIDER}
                subtitle="Rotate"
                field="rotate"
                value={value?.rotate }
                min={-180}
                max={180}
                stepSize={1}
                labelStepSize={45}
                editable
                onChange={onChange}
                default={0}
                postfix="degrees"
            />
        } 
        {
            !(disabled_fields || []).includes( "opacity" )  && <FieldInput
                type={SCALAR_TYPES.SLIDER}
                subtitle="Opacity"
                field="opacity"
                value={value?.opacity }
                min={0}
                max={1}
                stepSize={.1}
                labelStepSize={.2}
                editable
                onChange={onChange}
                default={1}
            />
        } 
        {
            !(disabled_fields || []).includes( "z" )  && <FieldInput
                type={SCALAR_TYPES.SLIDER}
                subtitle="Z index"
                field="z"
                value={ value?.z }
                min={0}
                max={100} 
                labelStepSize={25}
                editable
                onChange={onChange}
                default={1}
            />
        }
    </div>
}
const PositionDisable = (props: IPositionScalarProps): JSX.Element => {
    const [horz, ]   = useState<"left" | "right">( props.value?.right  ? "right"   : "left")
    const [vert, ]   = useState<"top" | "bottom">( props.value?.bottom ? "bottom"  : "top")
    const [value, ] = useState<any>( props.value || props.default || defaultPosition() )
    return <div className="container">
        <FieldInput
            type={SCALAR_TYPES.NUMBER} 
            subtitle={ horz } 
            value={ (value || {})[horz] }  
            postfix="pixels"
        />
        <FieldInput
            type={SCALAR_TYPES.NUMBER} 
            subtitle={ vert } 
            value={ (value || {})[vert] } 
            postfix="pixels"
        />
        <FieldInput
            type={SCALAR_TYPES.NUMBER}
            subtitle="Width" 
            value={value?.width } 
            default={100}
            postfix="pixels"
        />
        <FieldInput
            type={SCALAR_TYPES.NUMBER}
            subtitle="Height" 
            value={value?.height }  
            postfix="pixels"
        />
        <FieldInput
            type={SCALAR_TYPES.SLIDER}
            subtitle="Rotate" 
            value={value?.rotate } 
        />
        <FieldInput
            type={SCALAR_TYPES.SLIDER}
            subtitle="Opacity" 
            value={value?.opacity } 
            default={1}
        />
        <FieldInput
            type={SCALAR_TYPES.SLIDER}
            subtitle="Z index" 
            value={value?.z || 1}  
        />
    </div>
}